<template>
  <v-autocomplete
      :value="value"
      @input="$emit('input', $event)"
      :multiple="multiple"
      class="m-autocomplete"
      :label="label"
      :item-text="itemText"
      :item-value="itemValue"
      outlined
      :error="error"
      :disabled="disabled"
      append-icon="$chevron-arrow"
      :prepend-inner-icon="prepend_inner_icon"
      :items="items"
      :height="height"
      @change="$emit('change', $event)"
      hide-details
      :return-object="returnObject"
      :menu-props="{
    contentClass: 'rounded-dropdown',
    rounded: 'lg',
    maxHeight: 300
  }"
  >
    <template v-if="$scopedSlots.selection" v-slot:selection="{ item, index }">
      <slot name="selection" :item="item" :index="index"></slot>
    </template>

    <template v-if="$scopedSlots['prepend-item']" v-slot:prepend-item>
      <slot name="prepend-item"></slot>
    </template>

    <template v-if="$scopedSlots.item" v-slot:item="{ item, on, attrs }">
      <slot name="item" :item="item" :on="on" :attrs="attrs"></slot>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "m-autocomplete",
  props: {
    value: {
      type: [String, Number, Array, Object],
      default: null
    },
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    itemText: {
      type: String,
      default: null
    },
    itemValue: {
      type: String,
      default: null
    },
    prepend_inner_icon: {
      type: String,
      default: null
    },
    height: {
      type: Number,
      default: 34
    },
    returnObject: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
// Переопределение стандартных стилей для соотв. макету
.m-icon {
  width: 16px;
  height: 16px;
}

.m-autocomplete {
  height: v-bind('`${height}px`') !important;
  font-family: "Open Sans", sans-serif;
  border-radius: 6px !important;
}

.m-autocomplete :deep(.v-input__slot) {
  min-height: v-bind('`${height}px`') !important;
  height: v-bind('`${height}px`') !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.m-autocomplete :deep(.v-input__append-inner .v-icon) {
  height: 10px;
  width: 10px;
  font-size: 14px;
  line-height: 16px;
}

.m-autocomplete :deep(.v-icon) {
  height: 16px;
  width: 16px;
}

.m-autocomplete :deep(.v-label) {
  top: calc(v-bind('height') * 0.235px);
  color: var(--basic-grey);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 400;
}

.m-autocomplete :deep(.v-label--active) {
  top: calc(v-bind('height') * 0.4px);
  left: 0px !important;
}

.m-autocomplete :deep(.v-input__append-inner) {
  margin-top: calc(v-bind('height') * 0.226px);
}

.m-autocomplete :deep(.v-input__prepend-inner) {
  margin-top: calc(v-bind('height') * 0.147px);
}

.m-autocomplete :deep(.v-icon) {
  color: var(--basic-grey);
}

.m-autocomplete :deep(input) {
  color: var(--dark-grey);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
}

.m-autocomplete :deep(.v-select__selections) {
  color: var(--dark-grey);
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
}


.m-autocomplete :deep(.v-select__selections) {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
}


.m-autocomplete :deep(.v-select__selection--comma) {
  overflow: unset;
}

</style>

<style lang="scss">
.v-list-item--active::before {
  margin: 4px;
  border-radius: 10px;
  background-color: var(--another-grey);
}

.v-list-item__title {
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  font-weight: 400;
  color: var(--black);
}

.v-list-item {
  display: flex;
  flex-direction: row-reverse !important;
}

.v-list-item__action {
  margin-right: 0 !important;
}

.rounded-dropdown {
  margin-top: 4px;
  border-radius: 6px !important;
  box-shadow: 0px 4px 30px 0px #3334361A;
  overflow: auto !important;
}
</style>